module.exports = __webpack_public_path__ + "static/media/bitcoin.d9b76371.png";